export default __webpack_public_path__ + "c63461b1053419d77cc3d6c5f5988df3.png";